import axios from "axios";
import Swal from "sweetalert2";

export const getEmployes = async (
  page,
  branchId,
  name,
  sb_department_id,
  sb_branch_id,
  sb_nationality_id,
  active,
  lang
) => {
  try {
    let url = `/employes?page=${page}`;
    if (branchId) {
      url = `/employes?page=${page}&sb_branch_id=${branchId}`;
    } else if (
      name ||
      sb_department_id ||
      sb_branch_id ||
      sb_nationality_id ||
      active
    ) {
      url = `/employes?page=${page}&sb_department_id=${sb_department_id}&sb_branch_id=${sb_branch_id}&sb_nationality_id=${sb_nationality_id}&active${active}`;
    }
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const showEmployes = async (id, selectedCodeLang) => {
  try {
    let lang = localStorage.getItem("i18nextLng");
    if (selectedCodeLang) {
      lang = selectedCodeLang;
    }
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`/employes/${id}`, {
      headers: { Authorization: "Bearer " + `${brear}`, lang: lang },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const postEmployes = async (postData) => {
  try {
    const lang = localStorage.getItem("i18nextLng");
    const brear = localStorage.getItem("token");
    const { data } = await axios.post("/employes/store", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const updateEmployes = async (postData, id) => {
  try {
    const lang = localStorage.getItem("i18nextLng");
    const brear = localStorage.getItem("token");
    const { data } = await axios.post(`/employes/update/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const deleteEmployes = async (id) => {
  const brear = localStorage.getItem("token");
  const lang = localStorage.getItem("i18nextLng");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.post(`/employes/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export const postActiveEmployes = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/employes/active/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getAttachmentsEmployes = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`attachments/per/employe/${id}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const showAttachmentsEmployes = async (id) => {
  try {
    let lang = localStorage.getItem("i18nextLng");
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`/attachments/${id}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const postStatusAttachments = async (postData) => {
  try {
    const lang = localStorage.getItem("i18nextLng");
    const brear = localStorage.getItem("token");
    const { data } = await axios.post(`attachments/status/update`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postAttachmentsEmployes = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`attachments/store`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "Content-type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const updateAttachmentsEmployes = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`attachments/update/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "Content-type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getEmployesRequests = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`employe_requests/employe/${id}`, {
      Authorization: "Bearer " + `${brear}`,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const getEmployesAttendance = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`attendances/employe/${id}`, {
      Authorization: "Bearer " + `${brear}`,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const getPayrollsEmployes = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`payrolls/employe/${id}`, {
      Authorization: "Bearer " + `${brear}`,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getEmployesVisits = async (id) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.get(`trackings/employe/${id}`, {
      Authorization: "Bearer " + `${brear}`,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
